import _ from 'common-tools/LodashHelper'

export const PhoneFormatter = ({ value }) => {
  if (!value) {
    return ''
  }

  let phoneNumberString = `${value}`.replace(/\D/g, '')
  if (_.isString(phoneNumberString) === false) {
    return '!! Value Not String !!'
  }

  if (phoneNumberString.length !== 10) {
    return '!! Value Must Be 10 Digits !!'
  }

  var match = phoneNumberString.match(/^(\d{3})(\d{3})(\d{4})$/)
  if (match) {
    return '(' + match[1] + ') ' + match[2] + '-' + match[3]
  }
  return '!! Value can not be parsed !!'
}
